import { initAccordion } from "../utils-shared/accordion";

export function initCookiesConsent() {
  const consentAcceptBtn = document.querySelectorAll('.js-consent_accept');
  const consentDenyBtn = document.querySelectorAll('.js-consent_deny');
  const consentSavePreferences = document.querySelectorAll('.js-consent_preferences')[0];
  const consentCheckboxes = document.querySelectorAll('.js-header_checkbox');
  const cookiesConsent = document.querySelectorAll('.js-cookie_consent')[0];

  const isConsentModeCookie = hasConsentModeCookie('consent_data');

  if (isConsentModeCookie) {
    return;
  }

  cookiesConsent.classList.add('m-active');

  initAccordion();

  // create list of cookie categories
  const cookieCategories = {};

  if (consentCheckboxes.length) {
    consentCheckboxes.forEach(consentCheckbox => {
      cookieCategories[consentCheckbox.name] = 'denied';
    })
  }

  // Reject all Cookies
  consentDenyBtn && consentDenyBtn.forEach(consentDeny => {
    consentDeny.addEventListener('click', () => {
      for (let key in cookieCategories) {
        cookieCategories[key] = 'denied';
      }

      updateConsentStorage(cookieCategories);

      cookiesConsent.remove();
      document.body.classList.remove('popup-open');
    });
  });

  // Accept all Cookies
  consentAcceptBtn && consentAcceptBtn.forEach(consentDeny => {
    consentDeny.addEventListener('click', () => {
      for (let key in cookieCategories) {
        cookieCategories[key] = 'granted';
      }

      updateConsentStorage(cookieCategories);

      cookiesConsent.remove();
      document.body.classList.remove('popup-open');
    });
  });


  // Custom selection of Cookies
  consentSavePreferences && consentSavePreferences.addEventListener('click', () => {
    consentCheckboxes && consentCheckboxes.forEach(consentCheckbox => {
      cookieCategories[consentCheckbox.name] = consentCheckbox.checked ? 'granted' : 'denied';

      updateConsentStorage(cookieCategories);

      cookiesConsent.remove();
      document.body.classList.remove('popup-open');
    });
  })
}

function updateConsentStorage (cookieCategories) {
  gtag('consent', 'update', cookieCategories);
  setConsentModeCookie('consent_status', 'selected');
  setConsentModeCookie('consent_data', JSON.stringify(cookieCategories));
}

function setConsentModeCookie(name, value){
  let date = new Date();
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));

  let expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function hasConsentModeCookie (name) {
  return document.cookie.split('; ').some(cookie => cookie.startsWith(name + '='));
}
